const prefix = 'Nurse';
const path = '/cong-tac-vien/';

export default [
	{
		path: path,
		name: 'Welcome',
		component: () => import('@/views/Nurse/IntroPage.vue'),
		meta: {
			layout: 'NurseLandingPage',
		},
	},
	{
		path: path + 'trang-chu',
		name: prefix + 'Home',
		component: () => import('@/views/Nurse/Home.vue'),
		meta: {
			layout: 'MenuWithLogo',
		},
	},
	{
		path: path + 'dang-ky',
		name: 'Register',
		component: () => import('@/views/Nurse/RegisterByStep.vue'),
		meta: {
			layout: 'Default',
		},
	},
	{
		path: path + 'dang-nhap',
		name: 'Login',
		component: () => import('@/views/Nurse/Login.vue'),
		meta: {
			layout: 'Menu',
		},
	},
	{
		path: path + 'login-link',
		name: prefix + 'LoginLink',
		component: () => import('@/views/Nurse/LoginLink.vue'),
		meta: {
			layout: 'Empty',
		},
	},
	{
		path: path + 'khoi-phuc-mat-khau',
    alias: ['/nurse/reset-password'],
		name: 'ResetPassword',
		component: () => import('@/views/Nurse/ResetPassword.vue'),
		meta: {
			layout: 'Menu',
		},
	},
	{
		path: path + 'quen-mat-khau',
		name: 'ForgotPassword',
		component: () => import('@/views/Nurse/ForgotPassword.vue'),
		meta: {
			layout: 'Menu',
		},
	},
	{
		path: path + 'nguoi-dung',
		name: prefix + 'User',
		component: () => import('@/views/Nurse/User.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
	{
		path: path + 'ho-so',
		name: prefix + 'Profile',
		component: () => import('@/views/Nurse/Profile.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
	{
		path: path + 'thu-nhap',
		name: prefix + 'Payments',
		component: () => import('@/views/Nurse/Payments.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
	{
		path: path + 'dich-vu',
		name: prefix + 'Service',
		component: () => import('@/views/Nurse/Service.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
	{
		path: path + 'thoi-gian-hoat-dong',
		name: prefix + 'Availabilities',
		component: () => import('@/views/Nurse/Availabilities.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
	{
		path: path + 'ngan-hang',
		name: prefix + 'Bank',
		component: () => import('@/views/Nurse/Bank.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
	{
		path: path + 'lich-hen',
		name: `${prefix}Bookings`,
		component: () => import('@/views/Nurse/Booking.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
	{
		path: path + 'lich-hen/:id',
		name: `${prefix}BookingDetail`,
		component: () => import('@/views/Nurse/BookingDetail.vue'),
		meta: {
			layout: 'MenuWithProfile2',
		},
	},
	{
		path: path + 'thong-bao',
		name: `${prefix}Notification`,
		component: () => import('@/views/Nurse/Notify.vue'),
		meta: {
			layout: 'MenuWithProfile',
		},
	},
];
